module.exports = __webpack_public_path__ + "client booking calendar.png?d6f10d7439acd9f313afb40077917041";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/client booking calendar.png
// module id = 357
// module chunks = 0